module.exports = __webpack_public_path__ + "static/media/Table_Games@3x.fc8e9bb4.png";